import { RouterProvider } from "react-router-dom";
import { Providers } from "./providers";
import { SessionGate } from "./SessionGate";
import { router } from "./router";
import { Toaster } from "@/ui";

export function App() {
  return (
    <Providers>
      <SessionGate>
        <RouterProvider router={router} />
      </SessionGate>
      <Toaster />
    </Providers>
  );
}
